import React from 'react';
import ReactMarkdown from "react-markdown";
import { IFrontTask } from "../../../../interfaces/ITask";
import { formatTaskFlow } from "../../../../Utils/taskUtils";
import { censorEmailString } from '../../../../Utils/taskUtils';

interface TaskProblemSummaryProps {
  task: IFrontTask;
  userRole: string;
}

const TaskProblemSummary: React.FC<TaskProblemSummaryProps> = ({ task, userRole }) => {
  return (
    <div className="task-info-card">
      <h3>📝 Resumo do Problema</h3>
      
      {task.flow != null && task.flow.length > 0 && (
        <div className="task-info-item">
          <div className="task-info-icon">🔄</div>
          <div className="task-info-content">
            <div className="task-info-label">Fluxo</div>
            <div className="task-info-value">{formatTaskFlow(task.flow)}</div>
          </div>
        </div>
      )}

      <div className="task-description-section">
        <div className="task-description-header">
          <div className="task-info-icon">📄</div>
          <div className="task-info-label">Descrição</div>
        </div>
        <div className="task-description-content">
          {task.description != undefined && task.description != null ? (
            <ReactMarkdown className="markdown">
              {userRole === "Viewer"
                ? censorEmailString(task.description.replace(/\n/g, "  \n"))
                : task.description.replace(/\n/g, "  \n")}
            </ReactMarkdown>
          ) : (
            <span className="no-description">Nenhuma descrição fornecida</span>
          )}
        </div>
      </div>

      {userRole !== 'Viewer' && task.privateDescription && (
        <div className="task-private-description-section">
          <div className="task-description-header">
            <div className="task-info-icon">🔒</div>
            <div className="task-info-label">Descrição Privada</div>
            <span className="private-badge">Interno</span>
          </div>
          <div className="task-private-description-content">
            {task.privateDescription}
          </div>
        </div>
      )}
    </div>
  );
};

export default TaskProblemSummary; 